// Higher-order component
// This is a HOC which is needed to pass on parameters
// In the past, with the module react-router, we had by default this.props.match (this match doesn't exist anymore in the latest version)
// So now we needed to create a HOC that takes useParams from the react-router and extends the components
// that rely on parameters

import React from 'react';
import { useParams, Params } from 'react-router-dom';

interface WithParamsProps {
  params: Params<string>;
}

const withParams = <P extends {}>(Component: React.ComponentType<P>) => {
  return (props: P) => {
    const params = useParams<Params<string>>();
    return <Component {...(props as P & WithParamsProps)} params={params} />;
  };
};

export default withParams;
